import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';
import {
    Button,
    Layout, Row, Typography, Col, 
} from 'antd';
import './Panels.css';
import {useScreenSizeBelow} from "../../utility/hooks/useScreenSize";
import { DownOutlined, UpOutlined, SyncOutlined } from '@ant-design/icons';

const { Text } = Typography;


const PanelFrame = ({ scrollOnOpen, title, backgroundType, height, width, children, subtitle, collapsed, collapsible, subclass, 
                      tabMode = false, borderRadius, refreshable = false, onRefresh, refreshLoading }) => {

    const [minimised, setMinimised] = useState(collapsible);
    const [myRef] = useState(React.createRef());

    useEffect(() => {
        if (myRef && myRef.current && scrollOnOpen && !minimised)
        {
            window.scrollTo({ top: myRef.current.offsetTop - 100 });
        }
    }, [myRef, scrollOnOpen, minimised]);
    
    useEffect(() => {
        setMinimised(collapsed);
    }, [collapsed]);
    // Height not enforced on narrowest screens
    if (useScreenSizeBelow(576)) {
        height = null;
        width = null;
    }

    // Variable Styling
    let titleColour = 'var(--dp-panel-text-colour)';
    if (backgroundType === 'filled') {
        titleColour = 'var(--dp-panel-text-filled-colour)';
    }
    
    let panelStyle = height ? { height: height } : {};
    panelStyle = width ? { ...panelStyle, width: width } : {};
    let backgroundColor = 'var(--dp-panel-default-colour)';
    if (backgroundType === 'filled') {
        backgroundColor = 'var(--dp-panel-filled-colour)';
    } else if ((backgroundType === 'alternate')) {
        backgroundColor = 'var(--dp-panel-alternate-colour)';
    }
    panelStyle = { ...panelStyle, backgroundColor: backgroundColor };
    
    return (
        <Layout className={"dp-panel-frame-outer " + subclass}>
            <div ref={myRef} className={tabMode ? "dp-panel-frame-tabbed dp-panel-frame-left" : "dp-panel-frame dp-panel-frame-left"}  style={panelStyle}>
                <Row align={'middle'}>
                    <Col span={refreshable ? 17 : 20}>
                        <Text className="dp-panel-frame-title" style={{ color: titleColour }}>{title}</Text>
                    </Col>
                    <Col span={refreshable ? 7 : 4}>
                        <Row align={'middle'} justify={'end'}>
                            <Col>
                              {
                               refreshable
                               ?
                                <SyncOutlined style={{fontSize: '25px'}}
                                              spin={refreshLoading}
                                              onClick={(e) => {
                                                onRefresh();
                                              }}
                                />
                               :
                                <></>
                               }
                            </Col>
                            <Col style={{marginLeft: '5px'}}>
                              {collapsible ? <Button style={{marginBottom: 5}} onClick={() => setMinimised(!minimised)} icon={minimised ? <DownOutlined /> : <UpOutlined />} /> : <></>}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {minimised && collapsible ? <></> : (
                    <Row>
                        <Row>
                            <Text className="dp-panel-frame-subtitle" style={{ color:titleColour }}>{subtitle}</Text>
                        </Row>
                        <div className="dp-panel-frame-main">
                            {children}
                        </div>
                    </Row>
                )}
            </div>
        </Layout>
    );
}

// Validate the prop type parameters.
PanelFrame.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  backgroundType: PropTypes.string,  //default or filled or alternate
  height: PropTypes.number,          // optional - will take allowed height if not set
  children: PropTypes.oneOfType([PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)]).isRequired,
};

PanelFrame.defaultProps = {
    backgroundType: 'default',
};

export default PanelFrame;
